var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"treeCard"},[_c('b-alert',{attrs:{"show":""}},[_vm._v("You can double click on an item to turn it into a folder.")]),_c('ul',{attrs:{"id":"demo"}},[_c('treeItem',{staticClass:"item",attrs:{"item":_vm.treeData},on:{"make-folder":_vm.makeFolder,"add-item":_vm.addItem}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }